import Cookies from 'js-cookie'

export const TOKEN_KEY = 'Admin-Token'
import store from '../store'

export const setToken = (token) => {
  sessionStorage.setItem(TOKEN_KEY, token)
}

export const getToken = () => {
  const token = sessionStorage.getItem(TOKEN_KEY)
  if (token) return token
  else return false
}

export const removeToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem('store');
  store.commit("updateToken", '');
  store.commit("updateAccountInfo", '');
}



// WEBPACK FOOTER //
// ./src/libs/cookieUtil.js